
<!--DESKTOP HOMEBANNER-->
<div class="container-fluid">
    <div class="row">
        <div class="col-12 home-banner nopadding banner-container-no-overflow">
            <!-- ADD PICTURE ELEMENT FOR WEBP -->
            <img src="../../../assets/site-theme/HomeBannerDesktop.jpg" alt="Heating and Cooling">
            <div class="banner-caption">
                <h1>Here's One Thing Less<br>To Worry About</h1>
            </div>
        </div>
    </div>
</div>

<!--HOMEBANNER 480-->
<div class="container-fluid">
    <div class="row home-banner-480 pt-50">
        <div class="col-12 nopadding banner-container-no-overflow">
            <img src="../../../assets/site-theme/HomeBanner480.jpg" alt="Heating and Cooling">
        </div>
        <div class="banner-caption-480">
            <h1>Here's One Thing Less To Worry About</h1>
        </div>
    </div>
</div>

<!--HOMEBANNER 768-->
<div class="container-fluid">
    <div class="row home-banner-768 pt-50">
        <div class="col-12 nopadding banner-container-no-overflow">
            <img src="../../../assets/site-theme/HomeBanner768.jpg" alt="Heating and Cooling">
        </div>
        <div class="banner-caption-768">
            <h1>Here's One Thing Less To Worry About</h1>
        </div>
    </div>
</div>

<div class="container-fluid reduced-padding desktop-margin-top">
    <!--3 MAIN SEVICE CARDS-->
    <div class="row pt-3">
        <div class="col-sm-4">
            <div class="card transparent-card">
                <div class="card-header d-flex justify-content-center">
                    <div class="i-circle">
                        <i class="text-red fa fa-solid fa-fire"></i>
                    </div>
                </div>
                <div class="card-body text-center">
                    <h2>Heating</h2>
                    <p class="pt-2">Since Edmonton is known for its cooler climate, our heating experts will help you maximize the comfort level of your home even through our sub-zero winters.
                        <br><a routerLink="/heating" href="/heating" class="text-red">Read More</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="col-sm-4 mobile-pt">
            <div class="card transparent-card">
                <div class="card-header d-flex justify-content-center">
                    <div class="i-circle rounded-circle">
                        <i class="text-blue fa fa-solid fa-snowflake"></i>
                    </div>
                </div>
                <div class="card-body text-center">
                    <h2>Cooling</h2>
                    <p class="pt-2">Edmonton weather is changing and the need to have climate control through these hot summer months is a must. Our cooling experts will help you beat the heat.
                        <br><a routerLink="/cooling" href="/cooling" class="text-blue">Read More</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="col-sm-4 mobile-pt">
            <div class="card transparent-card">
                <div class="card-header d-flex justify-content-center">
                    <div class="i-circle rounded-circle">
                        <i class="text-yellow fa fa-solid fa-faucet"></i>
                    </div>
                </div>
                <div class="card-body text-center">
                    <h2>Plumbing</h2>
                    <p class="pt-2">Not just HVAC? That's right! Whether you need a new hot water tank, a pipe repaired, or a drain cleared, our plumbing experts are ready to help.
                        <br><a routerLink="/plumbing" href="/plumbing" class="text-yellow">Plumbing</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row pt-4 pb-4">
        <div class="col-12 d-flex justify-content-center">
            <h1 class="text-center line-height-360">Letting us handle your problems will feel <span class="text-blue">EAZY BREEZY</span></h1>
        </div>
    </div>
</div>

<div class="container-fluid service-bar">
    <!--SERVICE BUTTON-->
    <div class="row service-buttons pt-3">
        <div class="col-2">&nbsp;</div>
        <div class="col-8 d-flex justify-content-center">
            <div 
                class="service-button d-flex justify-content-center"
                [ngClass]="heatingActive === true ? 'service-heating-active' : ''"
                (click)="setService('heating')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-fire"></i></div>
                <div class="service-button-text">
                    <h2>Heating</h2>
                </div>
            </div>
            <div 
                class="service-button d-flex justify-content-center"
                [ngClass]="coolingActive === true ? 'service-cooling-active' : ''"
                (click)="setService('cooling')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-snowflake"></i></div>
                <div class="service-button-text">
                    <h2>Cooling</h2>
                </div>
            </div>
            <div 
                class="service-button d-flex justify-content-center" 
                [ngClass]="plumbingActive === true ? 'service-plumbing-active' : ''"
                (click)="setService('plumbing')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-faucet"></i></div>
                <div class="service-button-text">
                    <h2>Plumbing</h2>
                </div>
            </div>
        </div>
        <div class="col-2">&nbsp;</div>
    </div>

    <!--SERVICE-BUTTON-360-->
    <div class="row service-buttons-360">
        <div class="col-12 d-flex justify-content-center">
            <div 
                class="service-button-360 d-flex justify-content-center"
                [ngClass]="heatingActive === true ? 'service-heating-active' : ''"
                (click)="setService('heating')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-fire"></i></div>
            </div>
            <div 
                class="service-button-360 d-flex justify-content-center"
                [ngClass]="coolingActive === true ? 'service-cooling-active' : ''"
                (click)="setService('cooling')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-snowflake"></i></div>
            </div>
            <div 
                class="service-button-360 d-flex justify-content-center" 
                [ngClass]="plumbingActive === true ? 'service-plumbing-active' : ''"
                (click)="setService('plumbing')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-faucet"></i></div>
            </div>
        </div>
    </div>

    <!--SERVICE BUTTON 481-->
    <div class="row service-buttons-481">
        <div class="col-12 d-flex justify-content-center">
            <div 
                class="service-button-481 d-flex justify-content-center"
                [ngClass]="heatingActive === true ? 'service-heating-active' : ''"
                (click)="setService('heating')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-fire"></i></div>
                <div class="service-button-text">
                    <h2>Heating</h2>
                </div>
            </div>
            <div 
                class="service-button-481 d-flex justify-content-center"
                [ngClass]="coolingActive === true ? 'service-cooling-active' : ''"
                (click)="setService('cooling')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-snowflake"></i></div>
                <div class="service-button-text">
                    <h2>Cooling</h2>
                </div>
            </div>
            <div 
                class="service-button-481 d-flex justify-content-center" 
                [ngClass]="plumbingActive === true ? 'service-plumbing-active' : ''"
                (click)="setService('plumbing')"
            >
                <div class="service-button-icon"><i class="fa fa-solid fa-faucet"></i></div>
                <div class="service-button-text">
                    <h2>Plumbing</h2>
                </div>
            </div>
        </div>
    </div>

    <!--OUR SERVICES-->
    <div class="row pt-25">
        <div class="col-md-6">&nbsp;</div>
        <div class="col-md-6 center-360 col-md-6">
            <h1 *ngIf="heatingActive === true">Our <span class="text-red">Services</span></h1>
            <h1 *ngIf="coolingActive === true">Our <span class="text-blue">Services</span></h1>
            <h1 *ngIf="plumbingActive === true">Our <span class="text-yellow">Services</span></h1>
        </div>
    </div>

    <div class="row service-text" *ngIf="heatingActive === true">
        <div class="col-md-6">&nbsp;</div>
        <div class="col-md-6">
            <div class="service-item pt-25 pt-0-360">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-red icon-install"></div></div>
                <div class="service-text">
                    <h3> Installation</h3>
                </div>
            </div>
            <div class="service-item pt-25">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-red icon-maintenance"></div></div>
                <div class="service-text">
                    <h3> Maintenance</h3>
                </div>
            </div>
            <div class="service-item pt-25">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-red icon-repair"></div></div>
                <div class="service-text">
                    <h3> Repair</h3>
                </div>
            </div>
        </div>
    </div>
    <div class="row service-text" *ngIf="coolingActive === true">
        <div class="col-md-6">&nbsp;</div>
        <div class="col-md-6">
            <div class="service-item pt-25 pt-0-360">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-blue icon-install"></div></div>
                <div class="service-text">
                    <h3>Installation</h3>
                </div>
            </div>
            <div class="service-item pt-25">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-blue icon-maintenance"></div></div>
                <div class="service-text">
                    <h3>Maintenance</h3>
                </div>
            </div>
            <div class="service-item pt-25">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-blue icon-repair"></div></div>
                <div class="service-text">
                    <h3>Repair</h3>
                </div>
            </div>
        </div>
    </div>
    <div class="row service-text" *ngIf="plumbingActive === true">
        <div class="col-md-6">&nbsp;</div>
        <div class="col-md-6">
            <div class="service-item pt-25 pt-0-360">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-yellow icon-install"></div></div>
                <div class="service-text">
                    <h3>Installation</h3>
                </div>
            </div>
            <div class="service-item pt-25">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-yellow icon-maintenance"></div></div>
                <div class="service-text">
                    <h3>Maintenance</h3>
                </div>
            </div>
            <div class="service-item pt-25">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-yellow icon-repair"></div></div>
                <div class="service-text">
                    <h3>Repair</h3>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid booking-bar text-end">
    <div class="row">
        <div class="col-sm-12 col-md-6 verticle-center-text text-right">
            <span class="center-360"><h2>Let us start your project today!</h2></span>
        </div>
        <div class="col-sm-12 col-md-6 action-button-wrapper center-360">
            <div class="action-button verticle-center-text" routerLink="/contact" href="/contact">
                <span>BOOK ONLINE</span>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid promotion-bar">
    <div class="row">
        <div class="col-sm-12 col-md-6 promotion-bar-text">
            <!--<span><h1>We are a <span class="text-yellow">certified</span><br>reseller of Coleman equipment!</h1></span>-->
            <span><h1>Ask us about our offers<br> on <span class="text-yellow">HVAC Equipment</span>.</h1></span>
        </div>
        <div class="col-sm-12 col-md-6">&nbsp;</div>
    </div>
</div>

<!--PROMOTION BAR 480-->
<div class="container-fluid promotion-bar-360">
    <div class="row">
        <div class="col-sm-12 promotion-bar-text">
            <!--<span><h1>We are a <span class="text-yellow">certified</span><br>reseller of Coleman equipment!</h1></span>-->
            <span><h1>Ask us about our offers<br> on <span class="text-yellow">HVAC Equipment</span>.</h1></span>
        </div>
    </div>
</div>

<!--PROMOTION BAR 768-->
<div class="container-fluid promotion-bar-768">
    <div class="row">
        <div class="col-sm-12 col-md-6 promotion-bar-text">
            <!--<span><h1>We are a <span class="text-yellow">certified</span><br>reseller of Coleman equipment!</h1></span>-->
            <span><h1>Ask us about our offers<br> on <span class="text-yellow">HVAC Equipment</span>.</h1></span>
        </div>
        <div class="col-sm-12 col-md-6">&nbsp;</div>
    </div>
</div>

<div class="container-fluid guarantee-bar">
    <div class="row">
        <div class="col-sm-3 d-flex justify-content-center">
            <div class="service-item pt-0-360">
                <div class="service-icon i-circle mr-3"><div class="icon-sprite icon-sprite-guarantee icon-yellow icon-guarantee"></div></div>
            </div>
        </div>
        <!--<div class="col-sm-3 service-item">
            <div class="service-icon i-circle"><div class="icon-sprite-guarantee icon-yellow icon-guarantee"></div></div>
        </div>-->
        <div class="col-sm-9 guarantee-text center-360 mobile-pt">
            <h2>We promise to be 100% honest and transparent with every single customer we encounter. Your satisfaction is our livelihood.</h2>
        </div>
    </div>
</div>